import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  Accordion,
} from "../styles/Global";
import { BiRefresh } from "react-icons/bi";
import { BsFilterRight } from "react-icons/bs";
import { connect, useSelector } from "react-redux";
//AG-Grid
import { AgGridReact } from "@ag-grid-community/react";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { auth } from "../services/firebaseConfig.js";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "../App.scss";
// import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ColumnsToolPanelModule } from "@ag-grid-enterprise/column-tool-panel";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import { ModuleRegistry } from "@ag-grid-community/core";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { setModal } from "../features/modals/modalSlice.js";
ModuleRegistry.registerModules([
  // ClientSideRowModelModule,
  ColumnsToolPanelModule,
  CsvExportModule,
  FiltersToolPanelModule,
  SetFilterModule,
]);

const mapDispatch = { setModal };

const GridTableSecure = ({
  data,
  dataCall,
  apiURL,
  dataCallBody,
  error,
  setModalData,
  ShowModalType,
  shouldShowModal,
  columnDefs,
  rowClassRules,
  defaultColDef,
  showSearchBar,
  paginationPageSize,
  refreshGrid,
  showFilter,
  noBorder,
  noHeader,
  isFullWidthRow,
  fullWidthCellRenderer,
  placeholderPlayerList,
  rowHeight,
  setModal,
  isGodPower,
  gridOptions
}) => {
  const modules = useMemo(
    () => [ServerSideRowModelModule, MenuModule, SetFilterModule],
    []
  );
  const [openFilter, setOpenFilter] = useState(false);
  const [format, setFormat] = useState("all");
  const [generation, setGeneration] = useState("all");
  console.log("GridTableSecure auth.currentUser: ", auth.currentUser);
  function HandleError(err) {
    console.log("HandleError GridTableSecure err: ", err);
  }
  
  async function GetNewToken() {
    const getToken = async () => {
      return await auth.currentUser.getIdToken(true);
    };
    const updatedToken = await getToken().catch(HandleError);
    return updatedToken;
  }
  
  // Helper function to safely get token with retries
  async function getTokenSafely(maxRetries = 3, retryDelay = 500) {
    let retries = 0;
    
    while (retries < maxRetries) {
      if (auth.currentUser) {
        return await auth.currentUser.getIdToken(true).catch(HandleError);
      }
      
      console.log(`Token unavailable, retry attempt ${retries + 1}/${maxRetries}`);
      // Wait before retrying
      await new Promise(resolve => setTimeout(resolve, retryDelay));
      retries++;
    }
    
    throw new Error("Authentication token unavailable after multiple attempts");
  }
  
  const datasource = placeholderPlayerList
    ? placeholderPlayerList
    : {
        getRows(params) {
          if (placeholderPlayerList) {
            console.log(
              "ag grid placeholderPlayerList: ",
              placeholderPlayerList
            );
            params.successCallback(placeholderPlayerList, 11);
          } else {
            params.request = { ...params.request, ...dataCallBody };
            console.log('GridTableSecure request: ', params.request);
            return getTokenSafely()
              .then((accessToken) => {
                console.log("datasource getrows ag grid: ", {
                  method: "post",
                  body: JSON.stringify(params.request),
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    Authorization: "Bearer " + accessToken,
                  },
                });
                return fetch(
                  ` https://us-central1-scoreholio.cloudfunctions.net/apisecurev2/${apiURL}`,
                  // ` http://localhost:5001/scoreholio/us-central1/apisecurev2/${apiURL}`,
                  {
                    method: "post",
                    body: JSON.stringify(params.request),
                    headers: {
                      "Content-Type": "application/json; charset=utf-8",
                      Authorization: "Bearer " + accessToken,
                    },
                  }
                );
              })
              .then((httpResponse) => httpResponse.json())
              .then((response) => {
                console.log("response: ", response);
                params.successCallback(response.rows, response.lastRow);
              })
              .catch((error) => {
                console.error("dataSource error: ", error);
                params.failCallback();
              });
          }
        },
      };

  const updateServerSideDatasource = useCallback(() => {
    gridRef.current.api.setServerSideDatasource(datasource);
  }, [dataCallBody]);

  function handleSearchChange(searchvalue) {
    // console.log("change", searchvalue);
    //set search param
    dataCallBody.search = searchvalue;
    //refresh table
    gridRef.current.api.setServerSideDatasource(datasource);
  }
  const onRowClicked = useCallback((event) => {
    const selectedRow = event.data;
    //do stuff with selectedRow
    console.log("selectedRow: ", selectedRow);
    if (shouldShowModal) {
      setModalData(selectedRow);
      ShowModalType();
      event.node.setSelected(false);
    }
    if (apiURL === "organizer/players") {
      setModal({
        orgModals: {
          showModal: true,
          modalType: 48,
          data: { ...selectedRow._source, accountid: auth.currentUser.uid },
        },
      });
    }
  }, []);

  const gridRef = useRef();
  // Update the default column definition to better support horizontal scrolling
  const defaultColDefFallback = useMemo(() => {
    return {
      resizable: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
      minWidth: 100, // Ensure columns have minimum width
    };
  }, []);
  // const getRowId = useMemo((params) => {
  //   const id = params;
  //   console.log("getRowId data: ", id);
  //   return (params) => params.data.id;
  // }, []);
  // const getRowId = (params) => params.data.userID;
  // console.log("getRowId: ", getRowId());
  const onGridReady = (params) => {
    gridRef.current.api.setServerSideDatasource(datasource);
  };
  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const refreshCache = useCallback((route) => {
    console.log("refreshCache: ", dataCallBody);
    gridRef.current.api.refreshServerSide({
      purge: true,
    });
  }, []);

  useEffect(() => {
    if (
      dataCallBody &&
      apiURL === "organizer/stats/tournaments" &&
      gridRef.current.api
    ) {
      console.log("GridTableSecure dataCallBody updated: ", dataCallBody);
      updateServerSideDatasource();
    }
  }, [dataCallBody]);

  const getRowHeight = useCallback(function (params) {
    return rowHeight ? rowHeight : 90;
  }, []);


    const sideBar = useMemo(() => {
      return {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressPivotMode: true,
              suppressValues: true,
              suppressRowGroups: true,
            },
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      };
    }, []);

  // console.log("format: ", format);
  //console.log("GridTable refreshGrid: ", refreshGrid);
  useEffect(() => {
    //console.log("RUNNING USEEFFECT GRIDTABLE:");
    if (refreshGrid > 0) refreshCache();
  }, [refreshGrid]);
  return (
    <div 
      style={{ 
        height: "100%", 
        width: "100%", 
        overflow: "hidden" // Ensures the container doesn't add its own scrollbars
      }} 
      className="ag-theme-alpine"
    >
      {showSearchBar && (
        <FlexRow
          justify="space-between"
          align="center"
          style={{ flex: 0, padding: "5px 10px 0 0" }}
        >
          <div
            className="inputField"
            style={{
              marginLeft: 10,
              flex: 1,
            }}
          >
            <FormInputField
              id="outlined-basic"
              label="Search"
              variant="outlined"
              fullWidth
              margin="dense"
              onChange={(e) => handleSearchChange(e.target.value)}
              style={{ padding: 0 }}
              size="small"
            />
          </div>
          <BiRefresh
            size={30}
            color={Global.blueLight}
            style={{
              padding: 2,
              marginTop: 5,
              marginLeft: 10,
              backgroundColor: "transparent",
              borderRadius: 20,
              cursor: "pointer",
            }}
            onClick={() => refreshCache()}
          />
          {showFilter && (
            <BsFilterRight
              size={30}
              color={openFilter ? Global.red : Global.blueLight}
              style={{
                padding: 2,
                marginTop: 5,
                marginLeft: 10,
                backgroundColor: "transparent",
                borderRadius: 20,
                cursor: "pointer",
              }}
              onClick={() => setOpenFilter(!openFilter)}
            />
          )}
        </FlexRow>
      )}
      <FlexColumn
        className={`filterSection ${openFilter && "showFilterSection"}`}
      >
        <FlexRow
          style={{
            padding: "15px 0",
            width: "100%",
          }}
        >
          <FormControl fullWidth style={{ marginRight: 10 }}>
            <InputLabel id="demo-simple-select-label">Format</InputLabel>
            <Select
              labelId="game-type-select-label"
              id="game-type-select"
              value={format}
              label="Format"
              onChange={(e) => {
                console.log("event: ", e);
                setFormat(e.target.value);
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="Round Robin">Round Robin</MenuItem>
              <MenuItem value="Single Elimination">Single Elimination</MenuItem>
              <MenuItem value="Double Elimination">Double Elimination</MenuItem>
              <MenuItem value="Pool Play">Pool Play</MenuItem>
              <MenuItem value="Set Schedule">Set Schedule</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Generation</InputLabel>
            <Select
              labelId="generation-select-label"
              id="generation-select"
              value={generation}
              label="Generation"
              onChange={(e) => {
                console.log("event: ", e);
                setGeneration(e.target.value);
              }}
            >
              <MenuItem value="all">All</MenuItem>
              <MenuItem value="singles">Singles</MenuItem>
              <MenuItem value="setTeams">Set Teams</MenuItem>
              <MenuItem value="blindDraw">Blind Draw</MenuItem>
              <MenuItem value="Squadholio">Squadholio</MenuItem>
              <MenuItem value="Switcholio">Switcholio</MenuItem>
            </Select>
          </FormControl>
        </FlexRow>
      </FlexColumn>
      <AgGridReact
        gridOptions={gridOptions}
        // getRowNodeId={getRowId}
        className={noBorder && "noBorder"}
        // serverSideStoreType="partial"
        rowModelType="serverSide"
        pagination="true"
        paginationPageSize={paginationPageSize ? paginationPageSize : "10"}
        cacheBlockSize="50"
        suppressMovableColumns="true"
        suppressContextMenu="true"
        modules={modules}
        // rowHeight={rowHeight}
        ref={gridRef}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef ? defaultColDef : defaultColDefFallback}
        rowClassRules={rowClassRules}
        rowSelection="single"
        onRowClicked={onRowClicked}
        onFirstDataRendered={onFirstDataRendered}
        onGridReady={onGridReady}
        domLayout="autoHeight"
        headerHeight={noHeader ? 0 : 30}
        isFullWidthRow={isFullWidthRow}
        fullWidthCellRenderer={fullWidthCellRenderer}
        getRowHeight={getRowHeight}
        // autoHeight={true}
        sideBar={isGodPower? sideBar : null}
      />
    </div>
  );
};

export default connect(null, mapDispatch)(GridTableSecure);
